import type { routerContract } from "@biteasy/contracts";
import { createORPCClient } from "@orpc/client";
import { RPCLink } from "@orpc/client/fetch";
import { BatchLinkPlugin } from "@orpc/client/plugins";
import type { ContractRouterClient } from "@orpc/contract";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import ky from "ky";

export interface ClientContext {
	headers?: Record<string, string>;
}

const link = new RPCLink<ClientContext>({
	url: `${import.meta.env.VITE_API_URL}/rpc`,
	headers: async ({ context }) => ({
		...context?.headers,
	}),
	fetch: (url, init) =>
		ky(url, {
			...init,
			credentials: "include",
			throwHttpErrors: false,
		}),
	plugins: [
		new BatchLinkPlugin({
			groups: [{ condition: () => true, context: {} }],
			// Exclude event iterator (SSE) requests from batching.
			exclude: ({ path }) => path.includes("export"),
		}),
	],
});

export const client: ContractRouterClient<
	typeof routerContract,
	ClientContext
> = createORPCClient(link);

export const orpc = createTanstackQueryUtils(client);
